var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQrIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30h90V0H0v120h30zm0 0M392 0v30h90v90h30V0zm0 0M482 482h-90v30h120V392h-30zm0 0M30 392H0v120h120v-30H30zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60v150h150v-90h30V90h-30V60zm120 120H91V90h90zm0 0M451 450V300h-60v-30h-30v30h-90v30h30v30h-30v30h30v60zM331 330h90v90h-90zm0 0M151 270h60v-30H61v30h60v30H91v30h30v60H91v30h30v30h150v-30h-30v-30h-30v30h-60v-30h30v-30h-30zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121 120h30v30h-30zm0 0M361 120h30v30h-30zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M391 210h60V60H301v150h60v30h30zm-60-30V90h90v90zm0 0M451 270v-30h-60v30zm0 0M361 360h30v30h-30zm0 0M241 330h30v30h-30zm0 0M181 360h30v-60h-30zm0 0M211 270h30v30h-30zm0 0M91 330H61v60h30v-60zm0 0M61 420h30v30H61zm0 0M241 60h30v30h-30zm0 0M241 180h30v-60h-30zm0 0M271 240v-30h-30v60h120v-30zm0 0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrIcon);
export default __webpack_public_path__ + "static/media/qrIcon.5a6ff3b1f2f1f4ec88a2b4ac95a37e05.svg";
export { ForwardRef as ReactComponent };